import { SelectControl } from "@wordpress/components";
import { __ } from '@wordpress/i18n';
import { VayuBlocksDevice} from '@vayu-blocks/device-control';
import { useState } from '@wordpress/element';

export const VayuBlocksSelectControl = ({value, onChange, responsive = false, ...props }) => {

    const device = VayuBlocksDevice();
    const [firstDesktop, setFirstDesktop] = useState(false);
    const [firstTablet, setFirstTablet] = useState(false);

    const updateResponsiveValue = (newVal) => {
        const currentValues = value?.value || {};
        const updatedAttributes = {
            ...currentValues,
            [device]: newVal,
        };

        const isFirstRun = !currentValues?.[device];
        const isTabletFirstRun = localStorage.getItem('firstTablet') || firstTablet;

        if (device === 'Desktop') {
            if (isFirstRun || firstDesktop) {
                updatedAttributes['Tablet'] = newVal;
                updatedAttributes['Mobile'] = newVal;
                localStorage.setItem('firstTablet', 'true');
                setFirstTablet(true);
                setFirstDesktop(true);
            }
        } else if (device === 'Tablet') {
            if (isTabletFirstRun) {
                updatedAttributes['Mobile'] = newVal;
                localStorage.removeItem('firstTablet');
                setFirstTablet(true);
                setFirstDesktop(false);
            }
        } else {
            setFirstTablet(false);
            setFirstDesktop(false);
        }

        onChange(value?.key, updatedAttributes);
    }

  return (
    <SelectControl
        className="vb-select-control"
        __nextHasNoMarginBottom={true}
        __next40pxDefaultSize={true}
        value={
            responsive
                ? value?.value?.[device] ?? 'auto'
                : value
        }
        onChange={
            responsive
                ? updateResponsiveValue
                : onChange
        }
        {...props}
    />
  )
}


{/* 
<VayuBlocksSelectControl
    label={<VayuBlocksDeviceControl label={__(label, 'vayu-blocks')} />}
    value={{key:'aspectRatio', value:attributes.aspectRatio}}
    options={options}
    onChange={(key,value)=>setAttributes({[key]:value})}
    responsive={true} 
/>

// "aspectRatio":{
//     "type":"object",
//     "default":{
//         "Desktop":"",
//         "Tablet":"",
//         "Mobile":""
//     }
// }
// }

-------------or--------------------

<VayuBlocksSelectControl
    label={__(label, 'vayu-blocks')}
    value={attributes.aspectRatio}
    options={options}
    onChange={}
/>
*/}